module.exports = __webpack_public_path__ + "static/img/Textbook.ba76759.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Textbook.png
// module id = jz09
// module chunks = 20